module.exports = __webpack_public_path__ + "static/img/aruxpay_logo_small.9e2a1cd5.svg";